import React from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import Mail from '@wix/da-ds/pkg/Icons/24x24/Mail';
import PlainButtonOrLink from '@wix/da-ds/pkg/Buttons/PlainButtonOrLink';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import Button from '../../../Button';
import VerificationEmailInput from '../../../VerificationEmailInput';
import verificationReminderStyles from './VerificationReminder.scss';
export const VerificationNeeded = ({ email, isUnverified, resendEmail, isEmailChangeInProgress, isResendInProgress, hideChangeEmail })=>{
    const { t } = useTranslation();
    const isChangeInProgress = isEmailChangeInProgress || isResendInProgress;
    return /*#__PURE__*/ React.createElement("div", {
        className: classnames(verificationReminderStyles['root'], isUnverified && verificationReminderStyles['doormat'])
    }, /*#__PURE__*/ React.createElement("div", {
        className: verificationReminderStyles['header']
    }, /*#__PURE__*/ React.createElement(Mail, {
        className: verificationReminderStyles['message-icon'],
        size: IconSize.MEDIUM
    }), t('siteHeader.verification.verifyEmail')), /*#__PURE__*/ React.createElement("div", {
        className: verificationReminderStyles['text']
    }, /*#__PURE__*/ React.createElement("p", null, t('siteHeader.verification.checkEmail'))), /*#__PURE__*/ React.createElement(Button, {
        isFakeButton: true,
        view: "b3",
        height: "medium",
        onClick: resendEmail,
        className: verificationReminderStyles['resend-button'],
        disabled: isChangeInProgress,
        forceHoverStateWhenDisabledBecauseReasons: isResendInProgress,
        fullWidth: false
    }, t(isResendInProgress ? 'siteHeader.verification.resending' : 'siteHeader.verification.resend')), /*#__PURE__*/ React.createElement("div", {
        className: verificationReminderStyles['text-small']
    }, isUnverified ? /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        href: "https://www.deviantartsupport.com/en/article/what-if-im-having-trouble-verifying-my-account",
        target: "_blank"
    }, t('siteHeader.verification.notMe', {
        email
    })) : t('siteHeader.verification.notMe', {
        email
    })), !(hideChangeEmail || isUnverified) && /*#__PURE__*/ React.createElement(VerificationEmailInput, {
        className: verificationReminderStyles['email-input']
    }));
};
VerificationNeeded.displayName = 'VerificationNeeded';
export default VerificationNeeded;

//# sourceMappingURL=VerificationNeeded.js.map